import * as Yup from "yup";

export const faqValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string()
    .test("not-empty", "Description cannot be empty", (value) => {
      return value !== null && value.trim() !== "<p></p>";
    })
    .required("Description is required"),
  language: Yup.string().required("Language is required"),
  crmProductId: Yup.string().required("Please select the Product"),
});
